"use client"

import React, { createContext, useState, useContext, useEffect } from "react"
import api from "../config/api"

const AuthContext = createContext(null)

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem("token")
    const savedUser = localStorage.getItem("user")

    if (token && savedUser) {
      setUser(JSON.parse(savedUser))
      loadUser()
    } else {
      setLoading(false)
    }
  }, [])

  const loadUser = async () => {
    try {
      const response = await api.get("/me")
      setUser(response.data)
      localStorage.setItem("user", JSON.stringify(response.data))
    } catch (error) {
      console.error("Kullanıcı bilgileri yüklenemedi:", error)
      logout()
    } finally {
      setLoading(false)
    }
  }

  const login = async (phone, password) => {
    try {
      const response = await api.post("/login", { phone, password })
      const { access_token, user: userData } = response.data

      localStorage.setItem("token", access_token)
      localStorage.setItem("user", JSON.stringify(userData))
      setUser(userData)

      return { success: true }
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || "Giriş başarısız",
      }
    }
  }

  const logout = () => {
    localStorage.removeItem("token")
    localStorage.removeItem("user")
    setUser(null)
    window.location.href = "/login"
  }

  const hasPermission = (permissionId) => {
    if (!user) return false
    if (user.role === "admin") return true
    return user.permissions?.some((p) => p.id === permissionId)
  }

  const value = {
    user,
    loading,
    login,
    logout,
    hasPermission,
    isAdmin: user?.role === "admin",
  }

  return React.createElement(AuthContext.Provider, { value }, children)
}

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error("useAuth must be used within AuthProvider")
  }
  return context
}
